export const DATA_TABLE_SECTION_I18N_PREFIX = "features.topics.components.data_table_section";

export const DATA_TABLE_SECTION_I18N_KEYS = {
  number_of_rows_displayed: "number_of_rows_displayed"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/DataTableSectioni18nConstants.js